const positiveCategoryNameArray = ['儲值']; // 商品價錢皆為正數的分類

// 判斷是否為正數的分類
export const isPositiveCategory = (categoryName: string) => {
  return positiveCategoryNameArray.indexOf(categoryName) > -1
}